// extracted by mini-css-extract-plugin
module.exports =  {"counter-container":"QDX2CLs","counterContainer":"QDX2CLs","counter":"AlgjZU1"};